import { obtenerFechaHoyISO } from "../../utils/horaLocal";

export const totalItems = items => Math.round(items.reduce((s, it) => s + Number(it.precioUnitario || 0) * Number(it.cantidad || 0), 0) * 100) / 100;

export function montosPorModoPago(modo, total) {
  const t = total > 0 ? String(total) : "";
  if (modo === "transferencia") return { montoEfectivo: "", montoTransferencia: t, montoCredito: "" };
  if (modo === "credito") return { montoEfectivo: "", montoTransferencia: "", montoCredito: t };
  if (modo === "varios") return {};
  return { montoEfectivo: t, montoTransferencia: "", montoCredito: "" };
}

export function errorVenta(form) {
  const hoy = obtenerFechaHoyISO();
  if (form.fechaVenta && form.fechaVenta > hoy) return "La fecha de venta no puede ser futura.";
  if (!form.nombreCliente?.trim()) return "Escribe el nombre del cliente.";
  if (!form.items?.length || form.items.some(it => !it.productoNombre?.trim() ||
    it.precioUnitario === "" || !Number.isFinite(Number(it.precioUnitario)) || Number(it.precioUnitario) < 0 ||
    !Number.isInteger(Number(it.cantidad)) || Number(it.cantidad) < 1)) return "Completa cada producto o servicio con nombre, cantidad y precio válidos.";
  const efectivo = Number(form.montoEfectivo || 0);
  const transferencia = Number(form.montoTransferencia || 0);
  const credito = Number(form.montoCredito || 0);
  if (![efectivo, transferencia, credito].every(n => Number.isFinite(n) && n >= 0)) return "Los pagos deben ser importes positivos o cero.";
  const total = totalItems(form.items);
  if (!Number.isFinite(total) || total <= 0) return "El total debe ser mayor a cero.";
  const pagado = Math.round((efectivo + transferencia + credito) * 100);
  if (pagado !== Math.round(total * 100)) return "La suma de efectivo, transferencia y crédito debe ser exactamente igual al total.";
  if (credito > 0 && !form.fechaLimitePago) return "Indica la fecha límite de pago.";
  return "";
}
